import React, { useState } from "react";
import Team from "../../components/about/Team";
import Partners from "../../components/partners/Partners";
import About_news from "../../components/blog/about_news";
import Story from "../../components/about/Story";
import Head from "next/head";
import Meta from "../../components/Meta";

const About = () => {
  const [video, setVideo] = useState(false);
  return (
    <>
      <Meta title="Smart Swap || Reflectdoge" />
      {/* <!-- Page title --> */}
      <section className="relative pt-24 lg:pb-96">
        <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
          <img
            src="/images/gradient.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
          <img
            src="/images/gradient_dark.jpg"
            alt="gradient dark"
            className="h-full w-full"
          />
        </picture>
        <div className="container">
          {/* <!-- Page Title --> */}
          <div className="mx-auto max-w-2xl py-16 text-center">
            <h1 className="font-display text-jacarta-700 mb-8 text-4xl font-medium dark:text-white">
              Smart Swap
            </h1>
            <p className="dark:text-jacarta-300 text-lg leading-normal mb-10">
              Buy Reflectdoge
            </p>
            <iframe className="h-[600px] min-h-max"
              title="Embedded Content"
              name="htmlComp-iframe"
              width="100%"
              height="100%"
              allow="fullscreen"
              data-src=""
              src="https://www-reflectdogebsc-com.filesusr.com/html/b1a947_5a59188b5bb51cd308be92f3e17b83f2.html"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
